// Phone mockup data
const screens = [
  {
    id: 'membresia',
    label: 'Mi membresía',
    description: 'Verifica tu estado en segundos.',
    mockup: (
      <div className="flex flex-col h-full">
        {/* App header */}
        <div className="rounded-b-2xl px-5 pt-5 pb-4" style={{ background: '#534AB7' }}>
          <p className="text-white/70 text-xs font-medium tracking-widest uppercase mb-1">Coverly</p>
          <p className="text-white font-bold text-base leading-tight">Mi membresía</p>
        </div>
        {/* Content */}
        <div className="flex-1 bg-[#F7F6FF] px-5 py-5 flex flex-col gap-4">
          {/* Status badge */}
          <div className="flex items-center justify-center gap-2 bg-green-50 border border-green-200 rounded-2xl py-3">
            <div className="w-3 h-3 rounded-full bg-green-500"></div>
            <span className="text-green-700 font-bold text-sm tracking-wide">ACTIVA</span>
          </div>
          {/* Info rows */}
          <div className="bg-white rounded-2xl p-4 space-y-3">
            <div>
              <p className="text-[#0A0A0A]/40 text-xs font-medium uppercase tracking-wide">Titular</p>
              <p className="text-[#0A0A0A] font-semibold text-sm mt-0.5">Carlos Méndez López</p>
            </div>
            <div className="border-t border-[#EEEDFE]"></div>
            <div>
              <p className="text-[#0A0A0A]/40 text-xs font-medium uppercase tracking-wide">Registro activo desde</p>
              <p className="text-[#0A0A0A] font-semibold text-sm mt-0.5">12 enero 2024</p>
            </div>
          </div>
          {/* Progress */}
          <div className="bg-white rounded-2xl p-4">
            <div className="flex justify-between items-center mb-2">
              <p className="text-[#0A0A0A]/50 text-xs font-medium">Período de carencia</p>
              <span className="text-green-600 text-xs font-bold">Completado</span>
            </div>
            <div className="w-full h-2 rounded-full bg-[#EEEDFE]">
              <div className="h-2 rounded-full bg-green-500 w-full"></div>
            </div>
          </div>
        </div>
      </div>
    ),
  },
  {
    id: 'familia',
    label: 'Mi familia',
    description: 'Todos los que amas, visibles en un solo lugar.',
    mockup: (
      <div className="flex flex-col h-full">
        {/* App header */}
        <div className="rounded-b-2xl px-5 pt-5 pb-4" style={{ background: '#534AB7' }}>
          <p className="text-white/70 text-xs font-medium tracking-widest uppercase mb-1">Coverly</p>
          <p className="text-white font-bold text-base leading-tight">Mi familia</p>
        </div>
        {/* Beneficiaries */}
        <div className="flex-1 bg-[#F7F6FF] px-4 py-4 flex flex-col gap-2.5">
          {[
            { name: 'Carlos Méndez', rel: 'Titular' },
            { name: 'Sofía Méndez', rel: 'Cónyuge' },
            { name: 'Miguel Méndez', rel: 'Hijo' },
          ].map((b) => (
            <div key={b.name} className="bg-white rounded-xl px-4 py-3 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-[#EEEDFE] flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-line text-[#534AB7] text-sm"></i>
                </div>
                <div>
                  <p className="text-[#0A0A0A] font-semibold text-xs leading-tight">{b.name}</p>
                  <p className="text-[#0A0A0A]/45 text-[10px]">{b.rel}</p>
                </div>
              </div>
              <div className="flex items-center gap-1 bg-green-50 border border-green-200 rounded-full px-2 py-0.5">
                <div className="w-1.5 h-1.5 rounded-full bg-green-500"></div>
                <span className="text-green-700 text-[9px] font-bold">Activo</span>
              </div>
            </div>
          ))}
          {/* Add slot */}
          <div className="border-2 border-dashed border-[#AFA9EC] rounded-xl px-4 py-3 flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-[#EEEDFE] flex items-center justify-center flex-shrink-0">
              <i className="ri-add-line text-[#534AB7] text-sm"></i>
            </div>
            <p className="text-[#534AB7] text-xs font-semibold">Agregar familiar</p>
          </div>
        </div>
      </div>
    ),
  },
  {
    id: 'pagos',
    label: 'Mis pagos',
    description: 'Historial de pagos claro y con reglas claras.',
    mockup: (
      <div className="flex flex-col h-full">
        {/* App header */}
        <div className="rounded-b-2xl px-5 pt-5 pb-4" style={{ background: '#534AB7' }}>
          <p className="text-white/70 text-xs font-medium tracking-widest uppercase mb-1">Coverly</p>
          <p className="text-white font-bold text-base leading-tight">Mis pagos</p>
        </div>
        {/* Payment history */}
        <div className="flex-1 bg-[#F7F6FF] px-4 py-4 flex flex-col gap-2.5">
          <p className="text-[#0A0A0A]/40 text-[10px] font-semibold uppercase tracking-widest px-1">Historial</p>
          {[
            { month: 'Julio 2026', date: '1 jul 2026' },
            { month: 'Junio 2026', date: '1 jun 2026' },
            { month: 'Mayo 2026', date: '1 may 2026' },
          ].map((p) => (
            <div key={p.month} className="bg-white rounded-xl px-4 py-3 flex items-center justify-between">
              <div>
                <p className="text-[#0A0A0A] font-semibold text-xs">{p.month}</p>
                <p className="text-[#0A0A0A]/40 text-[10px] mt-0.5">{p.date}</p>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-[#0A0A0A] font-bold text-sm">$399</span>
                <i className="ri-checkbox-circle-fill text-green-500 text-base"></i>
              </div>
            </div>
          ))}
          {/* Pay button */}
          <button className="mt-2 w-full bg-[#534AB7] text-white font-bold text-xs py-3 rounded-xl whitespace-nowrap cursor-pointer">
            Pagar este mes
          </button>
        </div>
      </div>
    ),
  },
];

export default function MembershipApp() {
  return (
    <section id="app-coverly" className="py-10 md:py-28" style={{ background: '#FFFFFF' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-7 md:mb-20 reveal">
          <span className="inline-block text-[#534AB7] text-xs font-semibold tracking-widest uppercase mb-4 border border-[#534AB7]/30 rounded-full px-4 py-1.5">
            Portal del cliente
          </span>
          <h2 className="font-title text-2xl sm:text-4xl md:text-5xl lg:text-6xl text-[#0A0A0A] mt-4 leading-tight">
            Todo bajo control.{' '}
            <span style={{ color: '#534AB7' }}>Desde tu celular.</span>
          </h2>
          <p className="text-[#0A0A0A]/50 text-sm md:text-lg mt-4 md:mt-5 max-w-2xl mx-auto leading-relaxed font-light">
            Consulta el estado de tu membresía, tus personas registradas y tus pagos en cualquier momento desde la app Coverly.
          </p>
        </div>

        {/* Phone mockups grid */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8 lg:gap-12 items-start">
          {screens.map((screen, i) => (
            <div
              key={screen.id}
              className="flex flex-col items-center reveal"
              style={{ transitionDelay: `${i * 0.15}s` }}
            >
              {/* Phone frame */}
              <div
                className="w-full max-w-[260px] rounded-[2.5rem] overflow-hidden"
                style={{
                  border: '8px solid #0A0A0A',
                  boxShadow: '0 32px 64px rgba(83,74,183,0.18), 0 8px 24px rgba(0,0,0,0.12)',
                  minHeight: '460px',
                }}
              >
                {/* Notch */}
                <div className="bg-[#0A0A0A] flex justify-center pt-2 pb-1">
                  <div className="w-20 h-5 bg-[#0A0A0A] rounded-full flex items-center justify-center">
                    <div className="w-2.5 h-2.5 rounded-full bg-[#1a1a1a]"></div>
                  </div>
                </div>
                {/* Screen content */}
                <div className="flex flex-col" style={{ minHeight: '420px' }}>
                  {screen.mockup}
                </div>
              </div>

              {/* Description */}
              <div className="text-center mt-6 max-w-[240px]">
                <h3 className="font-title text-base font-bold text-[#0A0A0A] mb-1">{screen.label}</h3>
                <p className="text-[#0A0A0A]/55 text-sm font-light leading-snug">{screen.description}</p>
              </div>
            </div>
          ))}
        </div>


      </div>
    </section>
  );
}
